export default "__VITE_ASSET__VnnAuTgV__"